export default __webpack_public_path__ + "static/media/image-cushion-b-w.aeb04a16.png";